// Filter sheet + auto-submitting toolbar controls for snippets/pc-results.liquid.
// The sheet traps focus while open, closes on Esc / scrim, and returns focus to its trigger (IS 5568 / WCAG).
const form = document.querySelector('[data-pc-results]');
if (form && form.querySelector('[data-pc-sheet-open]')) {
  const sheet = form.querySelector('[data-pc-sheet]');
  const scrim = form.querySelector('[data-pc-scrim]');
  const opener = form.querySelector('[data-pc-sheet-open]');
  const focusables = () => [...sheet.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select')];

  function open() {
    sheet.hidden = false;
    scrim.hidden = false;
    opener.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    sheet.querySelector('[data-pc-sheet-close]').focus();
  }
  function close() {
    sheet.hidden = true;
    scrim.hidden = true;
    opener.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    opener.focus();
  }
  opener.addEventListener('click', open);
  scrim.addEventListener('click', close);
  sheet.querySelector('[data-pc-sheet-close]').addEventListener('click', close);
  sheet.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    const f = focusables();
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // a tick in the sheet filters at once: the results behind the sheet, the counts and the
  // "הצגת N מוצרים" button refresh in place, the sheet stays open and focus stays on the same box
  let ctrl;
  sheet.addEventListener('change', async (e) => {
    const box = e.target;
    if (!(box instanceof HTMLInputElement) || box.type !== 'checkbox') return;
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form)) if (v !== '' && !(k === 'sort_by' && v === 'manual')) params.append(k, v);
    const url = `${form.getAttribute('action')}?${params}`;
    ctrl?.abort();
    ctrl = new AbortController();
    form.setAttribute('aria-busy', 'true');
    try {
      const html = await (await fetch(url, { signal: ctrl.signal })).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const swap = (sel) => { const a = form.querySelector(sel); const b = doc.querySelector(`[data-pc-results] ${sel}`); if (a && b) a.replaceWith(b); };
      ['[data-pc-live]', '.pc-count', '[data-pc-show]'].forEach(swap);
      // keep the groups the shopper opened open across the live re-render
      const openGrps = new Set([...sheet.querySelectorAll('details.pc-grp[open]')].map((d) => d.dataset.pcGrp));
      sheet.querySelector('.pc-sheet__body').innerHTML = doc.querySelector('[data-pc-sheet] .pc-sheet__body')?.innerHTML || '';
      sheet.querySelectorAll('details.pc-grp').forEach((d) => { if (openGrps.has(d.dataset.pcGrp)) d.open = true; });
      const n = doc.querySelector('[data-pc-sheet-open] .pc-tbtn__n');
      opener.querySelector('.pc-tbtn__n')?.remove();
      if (n) opener.append(n);
      const chips = document.querySelector('.pc-chips');
      const newChips = doc.querySelector('.pc-chips');
      if (chips && newChips) chips.replaceWith(newChips);
      const pages = document.querySelector('.pc-pages');
      const newPages = doc.querySelector('.pc-pages');
      if (pages && newPages) pages.replaceWith(newPages); else if (pages) pages.remove(); else if (newPages) form.after(newPages);
      history.replaceState(null, '', url);
      const again = [...sheet.querySelectorAll('input[type=checkbox]')].find((i) => i.name === box.name && i.value === box.value);
      again?.focus();
    } catch (err) {
      if (err.name !== 'AbortError') form.requestSubmit(); // offline / error: fall back to a normal page load
    } finally {
      form.removeAttribute('aria-busy');
    }
  });

  // toolbar switch and sort apply immediately; empty params are dropped so URLs stay clean
  form.querySelectorAll('[data-pc-autosubmit]').forEach((el) => el.addEventListener('change', () => form.requestSubmit()));
  form.addEventListener('formdata', (e) => {
    for (const [k, v] of [...e.formData.entries()]) if (v === '') e.formData.delete(k);
  });
}
